import { UI_CONFIG } from '../constants/config';

export const getTomorrowDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + UI_CONFIG.minFutureDate);
  return tomorrow.toISOString().split('T')[0];
};

export const getMinDateString = () => {
  return getTomorrowDate();
};

export const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00');
  return date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const isValidFutureDate = (dateString) => {
  if (!dateString) return true;
  const selectedDate = new Date(dateString);
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + UI_CONFIG.minFutureDate);
  minDate.setHours(0, 0, 0, 0);
  return selectedDate >= minDate;
};
